import { render, staticRenderFns } from "./invite-regular-user-dialog.component.vue?vue&type=template&id=9dff46b8"
import script from "./invite-regular-user-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./invite-regular-user-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dff46b8')) {
      api.createRecord('9dff46b8', component.options)
    } else {
      api.reload('9dff46b8', component.options)
    }
    module.hot.accept("./invite-regular-user-dialog.component.vue?vue&type=template&id=9dff46b8", function () {
      api.rerender('9dff46b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-setup/invite-regular-user-dialog/invite-regular-user-dialog.component.vue"
export default component.exports